import {type ErrorCode, isExpectedErrorCode} from '@/ts/types/dto/error-codes-dto';

/** Application error that carries a typed status code alongside the message */
export class AppError extends Error {
  // eslint-disable-next-line @typescript-eslint/parameter-properties
  constructor(public message: string, public statusCode: ErrorCode) {
    super(message);
    this.name = this.constructor.name;
    // V8-only API, absent from the TS DOM lib since 6.0.
    (Error as {captureStackTrace?(target: object, ctor: unknown): void})
      .captureStackTrace?.(this, this.constructor);
  }
}

/**
 * Whether the value is an expected business outcome rather than a fault. The global handlers in
 * main.ts need this because filtering at the producer only silences an error someone catches: an
 * expected rejection nobody handles reaches window.onunhandledrejection and gets reported there.
 */
export function isExpectedAppError(err: unknown): boolean {
  return err instanceof AppError && isExpectedErrorCode(err.statusCode);
}
